<template>
  <div>
    <v-card>
      <v-card-title>
        Listado de Clientes
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <Listado
          :datos="datos"
          :encabezados="encabezados"
          :acciones="acciones"
        ></Listado>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Listado from "@/components/Listado.vue";
export default {
  name: "Clientes_Listado",
  components: {
    Listado,
  },
  data() {
    return {
      datos: "/personas/cliente",
      encabezados: [
        {
          text: "Nombre",
          align: "start",
          value: "nombre",
        },
        { text: "Tipo Documento", value: "documento.tipo.descripcion" },
        { text: "Nro. Documento", value: "documento.numero" },
        { text: "Responsable Fiscal", value: "tipo_responsable.descripcion" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      acciones: {
        editar: "/personas/",
      },
    };
  },
  methods: {
    _nuevo() {
      this.$router.push(`/personas/nuevo/cliente`);
    },
  },
};
</script>
